import * as actionTypes from './actionTypes';
import { axiosProtected } from '../../axios-wizard';
import { normalize } from 'normalizr';
import * as schema from '../schema';


export const fetchUsers = (userIds) => {
    const url = '/api/users/' + userIds + '/';

    return dispatch => {
        dispatch( fetchUsersStart() );
        return axiosProtected.get( url )
            .then( response => {
               const normalizedUsers = normalize(response.data, { users: schema.arrayOfUsers  })
               dispatch(fetchUsersSuccess(normalizedUsers));
            } )
            .catch( error => {
                dispatch(fetchUsersFailed());
            } );
    };
};

export const fetchUsersStart = (  ) => {
    return {
        type: actionTypes.FETCH_USERS_START
    };
};

export const fetchUsersSuccess = ( users ) => {
    return {
        type: actionTypes.FETCH_USERS_SUCCESS,
        values: users
    };
};

export const fetchUsersFailed = () => {
    return {
        type: actionTypes.FETCH_USERS_FAILED
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users.js